import React from 'react'
import { StyledBlock, StyledBlockText, StyledButton, StyledNumber, StyledText } from './LocationJob.styled'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import { locationJobButtonEvent } from '../../utils/gtmEvents'

import RoutingEnum from '../../routes/appRoutes'
import LocalesJobOpeningsEnum from '../../enums/LocalesJobOpeningsEnum'
import LocalesFindJobsEnum from '../../enums/LocalesFindJobsEnum'
import LocationsSuccessFactor from '../../enums/LocationsSuccesFactorEnum'


const VALAIS_MATCH = 'Le Valais'
const VALAIS = 'Valais'

const LocationJob = ({ locationKey, jobsCount, light, locale }) => {
  const to = `${RoutingEnum.jobSearch}/#${
    locationKey.split('(')[0] === VALAIS_MATCH
      ? `s=${VALAIS}`
      : `l=${locationKey.split('(')[0]}`
  }`



  const jobsCountToDisplay = jobsCount <= 9 ? `0${jobsCount}` : jobsCount

  return (
    <StyledBlock $light={light}>
      <StyledBlockText>
        <StyledNumber>{jobsCountToDisplay}</StyledNumber>
        <StyledText>
          {LocalesJobOpeningsEnum[locale] || 'Job Openings'}
        </StyledText>
      </StyledBlockText>
      <StyledButton
        onClick={() => {
          // muscle_shoals campaign
          if(locationKey === LocationsSuccessFactor.muscle_shoals) {
            locationJobButtonEvent()
          }
        }}
        variant={ButtonVariantEnum.quaternary}
        to={to}>
        {LocalesFindJobsEnum[locale] || 'Find jobs'}
      </StyledButton>
    </StyledBlock>
  )
}

export default LocationJob
